export default "/images/vendor/flag-icon-css/flags/4x3/kr.svg?939387c390531d01a6877e2f6f272f56";